
import Vue from 'vue'

export default Vue.extend({
  name: 'ConfirmCheckbox',
  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '?',
    },
    link: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    confirmCheckboxRules: [
      (value: string) =>
        !!value || 'You have to accept above conditions in order to preceed.',
    ],
    confirmCheckbox: false,
  }),
  methods: {
    resetForm() {
      this.confirmCheckbox = false
      ;(this.$refs as any).confirmCheckboxForm.resetValidation()
    },
    cancelClicked() {
      this.$emit('input', false)
      this.resetForm()
    },
    yesClicked() {
      this.$emit('confirmed')
    },
  },
})
